<template>
  <layout-default-filters @open="$_OnOpen" @apply="$_applyQueryString"
  :hideButton="false">
    <template #superior>
    <div class='div-geral'>
      <div class='segundo-filtro'>
        <div class='radios'>
          <v-radio-group v-model="radioGroup" row>
            <v-radio
              v-for="n in 2"
              :key="n"
              :label="radioLabel[n - 1]"
              :value="n"
            ></v-radio>
          </v-radio-group>
        </div>
        <core-text-field 
          clearable 
          class='txt-filter' 
          @focus='toggleFilter(true)'
          @keydown.enter="$_load(1)" 
          v-model="nomevendedor"
          min="0"
          @keydown="bloquearCaracteresInvalidos"
          @input="garantirPositivo('cliente')"
          label='Descrição'
          :type='inputType'
        />
        <div class='btns-wrap'>
          <v-btn rounded color='primary' class='btns opacity-switch' @click='$_load(0)'>
            <v-icon>mdi-arrow-left-thick</v-icon>
          </v-btn>
          <v-btn rounded color='primary' class='btns opacity-switch reducesize' @click='$_load(1)'>
            <v-icon>mdi-arrow-left-thick</v-icon><v-icon>mdi-arrow-right-thick</v-icon>
          </v-btn>
          <v-btn rounded color='primary' class='btns-mini opacity-switch' @click='toggleFilter(false)'>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <template>
        <v-divider></v-divider>
          <div
            class="mx-auto cardlist"
            max-width="500"
            v-if='filtroInicial'
          >
            <v-list two-line class='scroll'>
              <v-list-item-group
                active-class="green--text"
                multiple
              >
                <template v-for="(item, index) in items">
                  <v-list-item :key="index">
                    <v-card class='cardpessoa' @click="$_onClickCard(item)">
                      <v-card-text class="pa-2">
                        <strong>{{ item.codigo }}</strong> - {{ item.descricao }}
                      </v-card-text>
                    </v-card>
                  </v-list-item>

                  <v-divider
                    v-if="index < items.length - 1"
                    :key="`div-${index}`"
                  ></v-divider>
                </template>
              </v-list-item-group>
            </v-list>
          </div>
          <v-divider></v-divider>
        </template>
      </div>
    </div>
    </template>
  </layout-default-filters>
</template>

<script>
import { mapMutations } from 'vuex';
import db from '@/plugins/dexie';
import { PESQUISA_STORAGE } from '@/constants/STORAGE';
import { getQueryValue, setQueryValue } from '@/services/query-string';
import LayoutDefaultFilters from '@/layouts/default/NewFilters.vue';
import CoreTextField from '@/components/core/text-field/Index.vue';
import errorHandler from '@/utils/error-handler';
import storage from '@/services/storage';

export default {
  name: 'ViewVendasFilters',

  components: {
    LayoutDefaultFilters,
    CoreTextField,
  },

  data() {
    return {
      items: [],
      radioGroup: 2,
      radioLabel: ['Código', 'Descrição'],
      nomevendedor: null, 
      filtroInicial: false,
      inputType: 'text',
      loading: false,
      filters: {
        codigopessoa: null,
      },
    };
  },

  computed: {
    tipoPesquisa() {
      return this.$route.query.tipo || 'Usuario';
    }
  },

  methods: {
    ...mapMutations({
      $_setRefresh: 'filter/refresh',
    }),

    garantirPositivo() {
      if (this.termoBusca && this.termoBusca < 0) {
        this.termoBusca = Math.abs(this.termoBusca).toString();
      }
    },

    bloquearCaracteresInvalidos(e) {
      if (['-', '+'].includes(e.key)) {
        e.preventDefault();
      }
    },

    getConfig() {
      let collection;
      let idKey;
      let descKey;

      switch (this.tipoPesquisa) {
        case 'Tipo de Pagamento':
          collection = db.tipopedidovenda; 
          idKey = 'idtipopedidovenda'; 
          descKey = 'descricao';
          break;

        case 'Plano de Pagamento':
          collection = db.planopagamento;
          idKey = 'idplanopagto';
          descKey = 'descricao';      
          break;

        case 'Forma de Pagamento':
          collection = db.formapagto;
          idKey = 'idformapagto';
          descKey = 'descricao';
          break;

        case 'Destino da Mercadoria':
          collection = db.destinoitem;
          idKey = 'iddestinoitem';
          descKey = 'descricao';
          break;

        default:
          console.warn('Tipo não mapeado no Filtro:', this.tipoPesquisa);
          return null;
      }
      return { collection, idKey, descKey };
    },

    async $_load(parametroLoad) {
      this.loading = true;
      try {
        if (parametroLoad === 2) {
          this.nomevendedor = null;
          this.filters.codigopessoa = null;
          storage.setItem(PESQUISA_STORAGE.textofiltro, '');
          this.toggleFilter(false);
          this.items = [];
          this.$_applyQueryString();
          return;
        }

        const config = this.getConfig();
        if (!config) {
          this.items = [];
          return;
        }

        let queryData;
        
        const termoPesquisa = this.nomevendedor ? this.nomevendedor.toString().trim() : '';

        if (termoPesquisa === '') {
          this.filters.codigopessoa = null; 
          storage.setItem(PESQUISA_STORAGE.textofiltro, '');
          
          queryData = await config.collection.limit(100).toArray();
        
        } else {
          if (this.radioGroup === 2) {
            // Busca por Descrição
            queryData = await config.collection
              .where(config.descKey)
              .startsWithIgnoreCase(termoPesquisa)
              .limit(100)
              .toArray();
          } else {
            // Busca por Código
            const valorBusca = parseInt(termoPesquisa);
            if (!isNaN(valorBusca)) {
              queryData = await config.collection
                .where(config.idKey)
                .equals(valorBusca)
                .limit(100)
                .toArray();
            } else {
              queryData = await config.collection
                .where(config.idKey)
                .equals(termoPesquisa)
                .limit(100)
                .toArray();
            }
          }
        }

        this.items = queryData.map(item => {
          const findValue = (obj, keyName) => {
            if (!keyName) return '---';
            if (obj[keyName] !== undefined) return obj[keyName];
            if (obj[keyName.toLowerCase()] !== undefined) return obj[keyName.toLowerCase()];
            const pascal = keyName.charAt(0).toUpperCase() + keyName.slice(1);
            if (obj[pascal] !== undefined) return obj[pascal];
            return '---';
          };

          return {
            codigo: findValue(item, config.idKey),
            descricao: findValue(item, config.descKey),
            original: item 
          };
        });
        
        if (this.items.length > 0) {
            this.toggleFilter(true);
        }

      } catch (err) {
        errorHandler.call(this, err);
        this.items = [];
      } finally {
        this.loading = false;
      }
    },

    $_applyQueryString() {
      if (!this.nomevendedor || this.nomevendedor.toString().trim() === '') {
          this.filters.codigopessoa = null;
          storage.setItem(PESQUISA_STORAGE.textofiltro, ''); 
      }

      const valorAtualNaUrl = this.$route.query.codigo;
      const novoValor = this.filters.codigopessoa;

      const strAtual = String(valorAtualNaUrl || '');
      const strNovo = String(novoValor || '');

      if (strAtual !== strNovo) {
          setQueryValue('codigo', novoValor ? novoValor : null); 
          
          this.$_setRefresh('S');
      }
    },

    $_OnOpen() {
      // Vazio: só carrega se clicar na lupa/enter
    },

    toggleFilter(show) {
      const opacity = document.querySelectorAll('.opacity-switch');
      this.filtroInicial = show;
      opacity.forEach(el => el.style.opacity = show ? '1' : '0');
    },

    $_onClickCard(item) {
      if (this.filtroInicial) {
        this.nomevendedor = `${item.codigo} - ${item.descricao}`;
        storage.setItem(PESQUISA_STORAGE.textofiltro, this.nomevendedor);

        this.filters.codigopessoa = item.codigo;

        this.toggleFilter(false);
      }
    },
  },

  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler() {
        this.filters.codigopessoa = getQueryValue('codigo', null);
        
        this.nomevendedor = null; 
        
        storage.setItem(PESQUISA_STORAGE.textofiltro, '');
        
        this.toggleFilter(false);
        this.items = [];
      },
    },
  },
};
</script>

<style scoped>

  .btns-wrap {
    display: flex;
    justify-content: space-around;
    height: 50px;
  }

  .opacity-switch {
    transition: opacity 0.3s;
  }

  .btns {
    width: 33%;
    transition: opacity 0.3s;
    opacity: 0;
  }

  .btns-mini {
    width: 10%;
    transition: opacity 0.3s;
    opacity: 0;
  }

  .segundo-filtro {
    /* Ajustes para quando este é o único filtro */
    position: relative;
  }
  .radios {
    transition: opacity 0.3s;
    /* opacity: 0; foi removido para que os radios sejam sempre visíveis */
  }

  .mx-auto.cardlist {
    transition: opacity 0.3s;
    transition: top 0.4s;
    height: 50vh;
    overflow-y: scroll;
    background-color: rgb(245, 24Example5, 245);
  }

  .cardpessoa {
    height: 80px;
    width: 100%;
    margin-top: 5px;
  }

  .txt-filter {
    height: 50px;
  }

</style>